import { createFileRoute } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";

import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import { Section } from "@/components/marketing/layout/Section";
import { Badge } from "@/components/ui/badge";
import { QualifierFlow } from "@/components/marketing/solution/QualifierFlow";

export const Route = createFileRoute("/proof-of-concept")({
  component: ProofOfConceptPage,
});

function ProofOfConceptPage() {
  return (
    <MarketingLayout>
      {/*
        Unlike the two A/B candidates, this page is permanent and indexed - it
        keeps its URL when the new homepage goes canonical, so it is in the
        sitemap and carries no noindex.
      */}
      <Helmet>
        <title>Do you qualify for a free proof of concept? | Larasoft</title>
        <meta
          name="description"
          content="Five questions, under two minutes. Find out whether your business qualifies for a free Larasoft proof of concept - built on your own data, answering your own question."
        />
        <link
          rel="canonical"
          href="https://larasoft.global/proof-of-concept"
        />
        <meta
          property="og:title"
          content="Do you qualify for a free proof of concept? | Larasoft"
        />
        <meta
          property="og:description"
          content="Five questions, under two minutes. No demos of someone else's data - we build the proof of concept on yours."
        />
        <meta
          property="og:url"
          content="https://larasoft.global/proof-of-concept"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <Section containerClassName="max-w-2xl space-y-8" className="py-14 sm:py-16">
        <div className="space-y-4">
          <Badge variant="info" className="w-max">
            Free proof of concept
          </Badge>
          <h1 className="text-3xl font-extrabold leading-tight text-brand-blue-dark sm:text-4xl">
            See if you qualify.
          </h1>
          <p className="text-lg text-slate-600">
            Five quick questions - under two minutes. We offer free proofs of
            concept where we can see a clear win for both sides, and this tells
            us, and you, whether that is likely.
          </p>
        </div>

        <QualifierFlow />
      </Section>
    </MarketingLayout>
  );
}
